import qs from 'qs';
import ENDPOINTS from 'tradera-constants/endpoints';
import {
    axiosWithTokenRefresh,
    axiosConfigs,
    utilizeCancelToken,
    finalizeResponse,
    handleError
} from 'tradera-utils/api';

export const fetchReviews = (feedbackIds, toLanguageCodeIso2) => {
    const { cancel, cancelToken } = utilizeCancelToken(
        'getProfileReviewsTranslated'
    );

    if (cancel) cancel();

    return axiosWithTokenRefresh()
        .get(ENDPOINTS.TRANSLATE_PROFILE_FEEDBACKITEMS, {
            cancelToken,
            ...axiosConfigs.authenticated,
            params: {
                feedbackIds,
                toLanguageCodeIso2
            },
            paramsSerializer: function(params) {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            }
        })
        .then(finalizeResponse())
        .catch(handleError());
};

export const fetchProfileModel = ({ memberId, role, rating, page }) => {
    const { cancel, cancelToken } = utilizeCancelToken(
        'FeedbackController.GetProfileModel'
    );

    if (cancel) cancel();

    return axiosWithTokenRefresh()
        .get(`${ENDPOINTS.GET_PROFILE_FEEDBACK_ITEMS}/${memberId}`, {
            cancelToken,
            ...axiosConfigs.authenticated,
            params: {
                role,
                rating,
                page
            }
        })
        .then(finalizeResponse())
        .catch(handleError());
};
